import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { useGetGradePropertiesQuery } from 'api/grade-properties'
import { useGetPrintConfigQuery } from 'api/print-config'
import { type LabelType, type GradeConfig, type GradeReasonProperties } from 'types'
import { useAuthentication } from 'utils/useAuthentication'

export interface ApplicationState {
  isManualEntryScreenOpen: boolean
  isKeyboardOpenWithClosure: boolean
  gradeReasonProperties: GradeReasonProperties[]
  gradeConfigs: GradeConfig[]
  printConfig: LabelType[]
}

const initialState: ApplicationState = {
  isManualEntryScreenOpen: false,
  isKeyboardOpenWithClosure: false,
  gradeReasonProperties: [],
  gradeConfigs: [],
  printConfig: []
}

export const fetchGradeReasonProperties = createAsyncThunk('gradeReasonProperties/fetchGradeReasonProperties', async () => {
  const isAuthenticated = useAuthentication()
  const response = useGetGradePropertiesQuery(undefined, { skip: !isAuthenticated })
  return response.data
})

export const fetchPrintConfig = createAsyncThunk('printConfig/fetchPrintConfig', async () => {
  const isAuthenticated = useAuthentication()
  const response = useGetPrintConfigQuery(undefined, { skip: !isAuthenticated })
  return response.data
})

export const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    switchManualEntryScreen: (state) => {
      state.isManualEntryScreenOpen = !state.isManualEntryScreenOpen
    },
    setKeyboardWithClosureOpen: (state, action) => {
      state.isKeyboardOpenWithClosure = action.payload.open
    },
    setGradeConfigs: (state, action) => {
      state.gradeConfigs = action.payload.gradeConfigs
    },
    setPrintConfig: (state, action) => {
      state.printConfig = action.payload.printConfig
    },
    setGradeReasonProperties: (state, action) => {
      state.gradeReasonProperties = action.payload.gradeReasonProperties
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchGradeReasonProperties.fulfilled, (state, action) => {
      state.gradeReasonProperties = action.payload ?? []
    })
  }
})

export const { actions, reducer } = applicationSlice
